var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1764 9.85355L18.1771 9.85421C18.2198 9.89677 18.2457 9.95327 18.25 10.0132V18.5C18.25 19.0967 18.0129 19.669 17.591 20.091C17.169 20.5129 16.5967 20.75 16 20.75H8C7.40326 20.75 6.83097 20.5129 6.40901 20.091C5.98705 19.669 5.75 19.0967 5.75 18.5V6.5C5.75 5.90326 5.98705 5.33097 6.40901 4.90901C6.83097 4.48705 7.40326 4.25 8 4.25H12.4697C12.536 4.2501 12.5994 4.27648 12.6462 4.32333L12.6464 4.32355L18.1764 9.85355ZM13.6036 5.95645L12.75 5.10289V6.31V9.25V9.75H13.25H16.19H17.3971L16.5436 8.89645L13.6036 5.95645ZM12.25 5.25V4.75H11.75H8C7.53587 4.75 7.09075 4.93437 6.76256 5.26256C6.43437 5.59075 6.25 6.03587 6.25 6.5V18.5C6.25 18.9641 6.43437 19.4092 6.76256 19.7374C7.09075 20.0656 7.53587 20.25 8 20.25H16C16.4641 20.25 16.9092 20.0656 17.2374 19.7374C17.5656 19.4092 17.75 18.9641 17.75 18.5V10.75V10.25H17.25H12.5041C12.4372 10.2485 12.3734 10.2213 12.3261 10.1739C12.2787 10.1266 12.2515 10.0628 12.25 9.99588V5.25Z",
    fill: "#424242",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.5d2fe0bd8fd69a594dd95d39f20f07b4.svg";
export { ForwardRef as ReactComponent };